import {styled} from "@mui/material/styles";
import {Box, Grid} from "@mui/material";

export const SubscriptionsHeader = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between"
}));

export const SubscriptionsSearchContainer = styled(Grid)(() => ({
  width: '80%',
}));

export const SubscriptionsCsvContainer = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: "flex-end",
  alignItems: 'center',
  width: '20%'
}));
